export default {
  privacyNotice: 'Privacy Notice',
  terms: 'Terms & Conditions',
  userAgreement: 'User Agreement',
  cookieStatement: 'Cookies Statement',
  application: 'Application'
}